import { render, staticRenderFns } from "./SitchThemePreview.vue?vue&type=template&id=4fda40b1&scoped=true&"
import script from "./SitchThemePreview.vue?vue&type=script&lang=ts&"
export * from "./SitchThemePreview.vue?vue&type=script&lang=ts&"
import style0 from "./SitchThemePreview.vue?vue&type=style&index=0&id=4fda40b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fda40b1",
  null
  
)

export default component.exports